var cov_e52fh0cw5 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Rule/regExp.ts",
      hash = "0b56dfcf9e615d821787148afc42e29cc23b9d94",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Rule/regExp.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 16
        },
        end: {
          line: 5,
          column: 39
        }
      },
      "1": {
        start: {
          line: 7,
          column: 64
        },
        end: {
          line: 17,
          column: 1
        }
      },
      "2": {
        start: {
          line: 8,
          column: 2
        },
        end: {
          line: 11,
          column: 3
        }
      },
      "3": {
        start: {
          line: 9,
          column: 4
        },
        end: {
          line: 9,
          column: 105
        }
      },
      "4": {
        start: {
          line: 10,
          column: 4
        },
        end: {
          line: 10,
          column: 15
        }
      },
      "5": {
        start: {
          line: 12,
          column: 2
        },
        end: {
          line: 16,
          column: 3
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 7,
            column: 15
          },
          end: {
            line: 7,
            column: 16
          }
        },
        loc: {
          start: {
            line: 7,
            column: 64
          },
          end: {
            line: 17,
            column: 1
          }
        },
        line: 7
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 7,
            column: 64
          },
          end: {
            line: 7,
            column: 65
          }
        },
        loc: {
          start: {
            line: 7,
            column: 112
          },
          end: {
            line: 17,
            column: 1
          }
        },
        line: 7
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 7,
            column: 16
          },
          end: {
            line: 7,
            column: 59
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 7,
            column: 57
          },
          end: {
            line: 7,
            column: 59
          }
        }],
        line: 7
      },
      "1": {
        loc: {
          start: {
            line: 8,
            column: 2
          },
          end: {
            line: 11,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 8,
            column: 2
          },
          end: {
            line: 11,
            column: 3
          }
        }, {
          start: {
            line: 8,
            column: 2
          },
          end: {
            line: 11,
            column: 3
          }
        }],
        line: 8
      },
      "2": {
        loc: {
          start: {
            line: 8,
            column: 6
          },
          end: {
            line: 8,
            column: 63
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 8,
            column: 6
          },
          end: {
            line: 8,
            column: 32
          }
        }, {
          start: {
            line: 8,
            column: 36
          },
          end: {
            line: 8,
            column: 63
          }
        }],
        line: 8
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import { deepMerge } from '../utils/objects';
import { getLocale } from '../locale';
var options = (cov_e52fh0cw5.s[0]++, {
  skipUndefined: true
});
export default (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_e52fh0cw5.b[0][0]++, {}),
      message = _ref.message;

  cov_e52fh0cw5.f[0]++;
  cov_e52fh0cw5.s[1]++;
  return function (regExp, msg) {
    cov_e52fh0cw5.f[1]++;
    cov_e52fh0cw5.s[2]++;

    if ((cov_e52fh0cw5.b[2][0]++, typeof regExp !== 'string') && (cov_e52fh0cw5.b[2][1]++, !(regExp instanceof RegExp))) {
      cov_e52fh0cw5.b[1][0]++;
      cov_e52fh0cw5.s[3]++;
      console.error(new Error("Rule \"reg\" param expect a RegExp object or a string, get ".concat(typeof regExp)));
      cov_e52fh0cw5.s[4]++;
      return null;
    } else {
      cov_e52fh0cw5.b[1][1]++;
    }

    cov_e52fh0cw5.s[5]++;
    return deepMerge({
      message: getLocale('rules.reg')
    }, deepMerge({
      message: message,
      regExp: regExp
    }, {
      message: msg
    }, options), options);
  };
});